// extracted by mini-css-extract-plugin
export default {"backdrop":"BackDrop_backdrop__-l3c5"};